// extracted by mini-css-extract-plugin
export default {"popupContainer":"DeleteAccountButton_popupContainer__Dy4Ne","backdrop":"DeleteAccountButton_backdrop__nLlOJ"};